(function(){
  function initCarousel(root){
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-pp-slide]'));
    var dots=root.parentNode.querySelector('[data-pp-dots]');
    var index=0;
    if(!slides.length||!dots)return;
    function show(next){
      index=(next+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.classList.toggle('is-hidden',i!==index);});
      Array.prototype.slice.call(dots.children).forEach(function(dot,i){
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',i===index?'true':'false');
      });
    }
    slides.forEach(function(_,i){
      var dot=document.createElement('button');
      dot.type='button';
      dot.setAttribute('aria-label','Show testimonial '+(i+1));
      dot.addEventListener('click',function(){show(i);});
      dots.appendChild(dot);
    });
    root.querySelector('[data-pp-prev]').addEventListener('click',function(){show(index-1);});
    root.querySelector('[data-pp-next]').addEventListener('click',function(){show(index+1);});
    show(0);
  }
  function init(){Array.prototype.forEach.call(document.querySelectorAll('[data-pp-carousel]'),initCarousel);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
